import React from 'react';
import classNames from 'classnames';
import './DndAdorner.less';

export interface IDndAdornerProps extends React.HTMLProps<HTMLDivElement> {
  zIndex?: number;
  left: number;
  top: number;
  width: number;
  height: number;
}

const getClassName = (className?: string) => classNames('dpc-dnd-adorner', className);

/**
 * Component frame during dnd operation.
 * It is supposed to be used together with "useDragAndDrop" hook.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export const DndAdorner = React.memo(function({
  width,
  height,
  left,
  top,
  zIndex,
  className,
  ...otherProps
}: React.PropsWithChildren<IDndAdornerProps>) {
  return <div className={getClassName(className)} style={{ width, height, left, top, zIndex }} {...otherProps}></div>;
});
